module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_close-907bd19cc71eca58105dd4f9570b4cab.png";